import axioApi, { setHeader } from 'api/root.api';

export const mainObject = async (token, projectId, modelId)=>{
    const urlEnd = '/editor/project/v1/mainObject';
    // setHeader('Access-Control-Allow-Origin', '*');
    setHeader('Content-Type', 'application/json');
    const response = await axioApi.post(urlEnd, { modelId:modelId, projectId:projectId });
    const result = response.data;
    return result;
};